import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Home } from '@mui/icons-material';
import styled from 'styled-components';
import { blogPosts } from '../../data/blogPosts';

const BreadcrumbsContainer = styled.nav`
  background: #f8f9fa;
  padding: 1rem 2rem;
  border-bottom: 1px solid #e9ecef;
  direction: rtl;
`;

const BreadcrumbsList = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

const BreadcrumbItem = styled.li`
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  color: #6c757d;
  
  &:not(:last-child)::after {
    content: '';
    margin: 0 0.5rem;
    width: 6px;
    height: 6px;
    border-right: 2px solid #6c757d;
    border-top: 2px solid #6c757d;
    transform: rotate(45deg);
  }
`;

const BreadcrumbLink = styled(Link)`
  color: #2F4F4F;
  text-decoration: none;
  display: flex;
  align-items: center;
  transition: color 0.3s ease;
  
  &:hover {
    color: #1c2f2f;
    text-decoration: underline;
  }
  
  &.active {
    color: #6c757d;
    pointer-events: none;
  }
`;

const BreadcrumbIcon = styled.span`
  margin-left: 0.25rem;
  display: flex;
  align-items: center;
`;

const Breadcrumbs = () => {
  const location = useLocation();
  
  const generateBreadcrumbs = () => {
    const pathnames = location.pathname.split('/').filter(x => x);
    const breadcrumbs = [
      {
        name: 'דף הבית',
        path: '/',
        icon: <Home fontSize="small" />
      }
    ];
    
    let currentPath = '';
    
    pathnames.forEach((name, index) => {
      currentPath += `/${name}`;
      
      // Translate route names to Hebrew
      const hebrewNames = {
        'about': 'אודות',
        'services': 'שירותים',
        'contact': 'צור קשר',
        'blog': 'בלוג',
        'calculator': 'מחשבון משכנתא',
        'accessibility': 'נגישות',
        'new': 'משכנתא חדשה',
        'refinance': 'מיחזור משכנתא',
        'rejected': 'משכנתא למסורבים',
        'consolidation': 'איחוד הלוואות',
        'reverse': 'משכנתא הפוכה',
        'transfer': 'גרירת משכנתא',
        'family': 'ייעוץ לכלכלת המשפחה',
        'credit': 'ייעוץ אשראי'
      };
      
      let displayName = hebrewNames[name] || name;

      // Handle blog post title in breadcrumbs
      if (pathnames[index-1] === 'blog') {
        const post = blogPosts.find(p => p.slug === name);
        if (post) displayName = post.title;
      }
      
      breadcrumbs.push({
        name: displayName,
        path: currentPath,
        isLast: index === pathnames.length - 1
      });
    });
    
    return breadcrumbs;
  };
  
  const breadcrumbs = generateBreadcrumbs();
  
  if (breadcrumbs.length <= 1) {
    return null;
  }
  
  return (
    <BreadcrumbsContainer aria-label="breadcrumb">
      <BreadcrumbsList>
        {breadcrumbs.map((breadcrumb, index) => (
          <BreadcrumbItem key={breadcrumb.path}>
            {breadcrumb.isLast ? (
              <BreadcrumbLink className="active">
                {breadcrumb.icon && (
                  <BreadcrumbIcon>{breadcrumb.icon}</BreadcrumbIcon>
                )}
                {breadcrumb.name}
              </BreadcrumbLink>
            ) : (
              <BreadcrumbLink to={breadcrumb.path}>
                {breadcrumb.icon && (
                  <BreadcrumbIcon>{breadcrumb.icon}</BreadcrumbIcon>
                )}
                {breadcrumb.name}
              </BreadcrumbLink>
            )}
          </BreadcrumbItem>
        ))}
      </BreadcrumbsList>
    </BreadcrumbsContainer>
  );
};

export default Breadcrumbs;
